"use client";
import React from "react";
import { useEffect, useState } from 'react';
import type { NextPage } from "next";
import HeaderPhoto from "../../../public/Header.png";
import Header2 from "../../../public/Headersmall.png";
import { Oswald, Roboto } from "next/font/google";
import Navbar3 from "../navbar3";
import { FaFacebook } from "react-icons/fa";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import Link from "next/link";
import { useRouter} from 'next/navigation';
// import

const oswalds = Oswald({ subsets: ["latin"] });
const roboto = Roboto({ weight: ["300"], subsets: ["latin"] });

interface Heading {
  head: string;
  slug: any
}

interface HeadingProps {
  heading: Heading;
  loading?: boolean;
  setLoading?: (loading: boolean) => void;
}

const Header: NextPage<HeadingProps> = ({ heading, loading, setLoading }) => {
  const [isContactUsPage, setIsContactUsPage] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsContactUsPage(window.location.pathname === '/contactus');
    }
  }, [router]);
  

  

  return (
    <div>
      <style jsx>
        {`
          .header-container {
            background-image: linear-gradient(
                to right,
                rgba(0, 0, 0, 0.2),
                rgba(0, 0, 0, 0.2)
              ),
              url(${HeaderPhoto.src});
          }
          @media (max-width: 648px) {
            .header-container {
              background-image: url(${Header2.src});
            }
          }
        `}
      </style>
      <div className={`bg-cover bg-center bg-no-repeat max-w-full ${loading ? 'bg-white' : 'header-container'}`}>
        <div className="flex flex-col justify-between items-center gap-[24px]">
          <div className="w-full">
            <div className="bg-[#201F5C] gap-2 py-2 w-full flex  md:flex-row flex-col items-center justify-center">
              <h1 className="font-normal text-[1rem]  max-[368px]:text-[0.7rem] text-white">
                Price may be higher or lower than face value.
              </h1>

              <a
                href="https://www.facebook.com/groups/KarmaTickets"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 text-[1rem] max-[368px]:text-[0.7rem] text-orange-500"
              >
                Connect with us on Facebook
                <FaFacebook className="text-orange-500" />
              </a>
            </div>
            {/* <Navbar className="bg-[#3BC3F2] w-full py-4" setLoading={setLoading} loading={loading} /> */}
            <Navbar3 className="bg-[#3BC3F2] w-full py-4" setLoading={setLoading} loading={loading} />
          </div>
          {
            loading ? (<div className='flex justify-center items-center h-[50vh]'>
              <LoadingAnimation />
            </div>) : (<>
              <div className="flex">
                <div className="flex flex-col justify-center items-center gap-[16px] px-4 ">
                  <div className="flex flex-col gap-[16px]">
                    <div className="flex justify-center">
                      <div className="px-8 py-4 bg-white bg-opacity-10 rounded-lg border-2 border-indigo-300 backdrop-blur-[18.40px] justify-center items-center gap-2.5 inline-flex">
                        <div
                          className={`text-white text-2xl md:text-5xl font-normal leading-[57.60px] ${oswalds.className}`}
                        >
                          {heading.head}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`md:flex flex-col items-center gap-4 hidden ${roboto.className}`}
                    >
                      {(heading?.slug !== 'mlb' && heading?.slug !== 'nfl' && heading?.slug !== 'nba' && heading?.slug !== 'nhl') && <div className="flex items-start gap-8">
                        <div className="w-[300px] h-[108px] bg-blue-950 py-2 px-6 flex flex-col justify-center items-center gap-2">
                          <div className="flex items-end gap-1">
                            {/* <Image
                            className="w-6 h-6 relative"
                            alt=""
                            width={6}
                            height={6}
                            src="/tick.svg"
                          /> */}
                            <div className="text-white text-19px font-bold leading-22.8">
                              Have a Question ?
                            </div>
                          </div>
                          <div className="flex flex-col items-center text-white text-base font-normal leading-tight">
                            <p>Please Read our <Link href="/faq"><span className="underline italic">FAQ&apos;s page</span></Link></p>
                          </div>
                        </div>

                        <div className="w-[300px] bg-blue-950 p-2 flex flex-col justify-start items-center gap-22">
                          <div className="h-70px flex flex-col justify-center items-center gap-2">
                            <div className="flex items-center gap-1">
                              {/* <img
                              className="w-6 h-6 relative"
                              alt=""
                              src="/tick.svg"
                            /> */}
                              <div className="text-white text-19px font-bold leading-22.8">
                                Customer Care
                              </div>
                            </div>
                            <div className="flex flex-col items-center text-white text-base font-normal leading-tight">
                              <p>7 days a week 9:30 am to 10 pm </p>
                              <p> EST visit our <Link href="/contactus"><span className="underline italic">Contact us</span></Link> page to</p>
                              <p>connect</p>
                            </div>
                          </div>
                        </div>
                      </div>}

                      {
                        (heading?.slug !== 'mlb' && heading?.slug !== 'nfl' && heading?.slug !== 'nba' && heading?.slug !== 'nhl') && <div className=" flex items-start gap-8">
                          <div className="w-[300px] bg-blue-950 p-2 flex flex-col justify-center items-center gap-2">
                            <div className="flex items-start gap-1">
                              {/* <img
                            className="w-6 h-6 relative"
                            alt=""
                            src="/tick.svg"
                          /> */}
                              <div className="text-white text-19px font-bold leading-22.8">
                                Valid Seats
                              </div>
                            </div>
                            <div className="flex flex-col items-center text-white text-base font-normal leading-tight">
                              <p>All listed tickets are valid and ready</p>
                              <p>to be shipped on the assigned</p>
                              <p>delivery date</p>
                            </div>
                          </div>

                          <div className="w-[300px] p-2 bg-blue-950 flex flex-col justify-center items-center gap-2">
                            <div className="flex items-end gap-1">
                              <div className="w-6 h-6 relative"></div>
                              {/* <img
                            className="w-6 h-6 relative"
                            alt=""
                            src="/tick.svg"
                          /> */}
                              <div className="text-white text-19px font-bold leading-22.8">
                                Full Refund
                              </div>
                            </div>
                            <div className="flex flex-col items-center text-white text-base font-normal leading-tight">
                              <p>On all cancelled events</p>
                              <p>Please read our <Link href="/faq"><span className="underline italic">FAQ&apos;s page</span></Link> for more</p>
                              <p>details.</p>
                            </div>
                          </div>
                        </div>
                      }

                      <div className="text-white font-bold text-19px leading-22.8 text-center">
                        For all website order questions, please make to read our <Link href="/faq"><span className="underline italic">FAQ&apos;s page</span></Link>
                        {!isContactUsPage && (
                          <>
                            <br />
                            OR visit our <Link href="/contactus"><span className="underline italic">CONTACT US</span></Link> page to connect with us via email or phone.
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className={`md:hidden flex flex-col items-center text-[18px] text-white font-medium leading-[120%] max-[356px]:text-[14px] max-[300px]:text-[14px] ${oswalds.className}`}
                    >
                      <h1>YOUR PASSPORT TO SPORTS,</h1>
                      <h1>CONCERTS, THEATRE, AND BEYOND</h1>
                    </div>

                    <div className=" sm:hidden w-full flex justify-center items-center">
                      <div className="w-[250px] bg-orange-500 p-2 flex flex-col justify-center items-center gap-2">
                        <div className="flex items-end gap-1">
                          <div className="text-base sm:text-lg font-bold  text-[#27276D]">
                            Have a Question ?
                          </div>
                        </div>
                        <div className="flex flex-col items-center text-center text-white text-base font-normal leading-tight">
                          {/*  <p>Please Read our <Link href="/faq"><span className="underline italic">FAQ's page</span></Link> to assist you especially after placing an order</p> */}
                          <p>Please Read our <Link href="/faq"><span className="underline italic"> FAQ&apos;s page</span></Link></p>
                        </div>
                      </div>
                    </div>

                    <div className="flex w-full-200%">
                      {/* <div className='relative flex items-center w-full-200% h-10 z-[1] rounded-lg focus-within:shadow-lg bg-white overflow-hidden max-md:h-8'>
                                        <IoSearch className='h-6 w-6 m-3' />
                                        <input type='text' className="h-full w-full outline-none text-sm text-gray-700 max-md:text-[13px] max-md:w-[270px] max-[348px]:w-[300px] " placeholder='Search by teams, artist, event or venue' />
                                    </div> */}
                    </div>
                  </div>

                  {/* <p className='text-white mb-[24px]'>For all website order questions, please contact Customer Care @ 437-370-2833
                            Make sure to leave a detailed message and include your Order Number if you have one.</p> */}
                </div>
              </div>
            </>)
          }
        </div>
      </div>
    </div>
  );
};

export default Header;
